import { observer } from 'mobx-react-lite';
import cls from 'classnames';

function PointsOfInterestHeader({ pointsOfInterest, selectedPoint, onPointClick, border = false }) {
  return (
    <div className="md:pt-5">
        
        <ul className="flex gap-32">
            {pointsOfInterest.map(point => (
                <li
                    key={point.key}
                    className={cls('mb-20 cursor-pointer text-xl uppercase text-dark-md-blue md:text-content', {
                        'fw-semibold': selectedPoint === point.name,
                    })}
                    onClick={() => {
                        onPointClick(point.name);
                    }}
                >
                    {point.name}
                </li>
            ))}
        </ul>
        {border ? <div className="mt-2 h-[1px] w-full bg-medium-electric-blue" /> : null}
    </div>
  );
}

export default observer(PointsOfInterestHeader);
